import {
  Wallet,
  CreditCard,
  Users,
  Repeat,
  CheckCircle2,
  ArrowLeftRight,
  FolderTree,
  DollarSign,
  Archive,
} from 'lucide-react';
import { useTranslation } from 'react-i18next';
import FeatureLayout from '../../components/layout/FeatureLayout';
import SEOHead from '../../components/common/SEOHead';

const sectionKeys = [
  { icon: CreditCard, key: 'multiAccount' },
  { icon: Users, key: 'sharedAccount' },
  { icon: Repeat, key: 'recurring' },
  { icon: CheckCircle2, key: 'validation' },
  { icon: ArrowLeftRight, key: 'transfers' },
  { icon: FolderTree, key: 'categorization' },
  { icon: DollarSign, key: 'credits' },
  { icon: Archive, key: 'archive' },
];

const recurrenceKeys = ['monthlyFixed', 'monthlyWeekday', 'weekly', 'biweekly', 'installments', 'annual'];

export default function FeatureOperations() {
  const { t } = useTranslation('features');

  return (
    <FeatureLayout
      breadcrumbs={[{ label: t('operations.title') }]}
    >
      <SEOHead
        title="Gestion des opérations - Multi-comptes et récurrences"
        description="Gérez vos opérations financières personnelles et communes. Multi-comptes bancaires, opérations récurrentes, validation, transferts internes et catégorisation avancée."
        path="/fonctionnalites/operations"
      />
      {/* Hero */}
      <section className="pub-hero py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <div className="pub-ico w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-6">
            <Wallet className="w-8 h-8" />
          </div>
          <h1 className="pub-title text-3xl sm:text-4xl font-bold mb-4">
            {t('operations.title')}
          </h1>
          <p className="pub-muted text-lg max-w-2xl mx-auto">
            {t('operations.subtitle')}
          </p>
        </div>
      </section>

      <section className="py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="grid gap-8">
            {sectionKeys.map((section, index) => (
              <div
                key={section.key}
                className={`flex flex-col md:flex-row items-start gap-6 p-6 rounded-xl ${
                  index % 2 === 0 ? 'pub-card' : 'pub-section-alt'
                }`}
              >
                <div className="pub-ico w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0">
                  <section.icon className="w-6 h-6" />
                </div>
                <div>
                  <h3 className="pub-title text-lg font-semibold mb-2">
                    {t(`operations.sections.${section.key}.title`)}
                  </h3>
                  <p className="pub-muted">{t(`operations.sections.${section.key}.description`)}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="pub-section-alt py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <h2 className="pub-title text-2xl font-bold mb-8 text-center">
            {t('operations.recurrenceTypes')}
          </h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {recurrenceKeys.map((key) => (
              <div key={key} className="pub-card p-4">
                <p className="font-medium text-sm">{t(`operations.recurrence.${key}.label`)}</p>
                <p className="pub-subtle text-xs mt-1">{t(`operations.recurrence.${key}.desc`)}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </FeatureLayout>
  );
}
